import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../_core/services/auth.service';
import { AppRoutes } from '../../app.routes';
import { AdminRoutes } from '../../admin/admin.routes';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.css'
})
export class PageNotFoundComponent {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  goHome() {
    if (this.authService.isAuthenticated()) {
      const roleId = this.authService.roleId;
      if (roleId && this.authService.hasAdminAccess) {
        this.router.navigate([AppRoutes.Admin, AdminRoutes.Sns, AdminRoutes.Dashboard]);
      } else {
        this.router.navigate([AppRoutes.Admin, AdminRoutes.Client, AdminRoutes.ClientDashboard]);
      }
    } else {
      this.router.navigate(['/auth/signin']);
    }
  }
}
